module.exports = __webpack_public_path__ + "static/media/samen_in_spanje.eb25595d.jpg";